import { getLengthWithSpecialSymbols } from '@gem/utils';

import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

const MIN_FIELD_SPACE_NAME_LENGTH = 2;

export const spaceNameValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value || value.length === 0) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  if (getLengthWithSpecialSymbols(value) < MIN_FIELD_SPACE_NAME_LENGTH) {
    return errorToText[ValidationErrorType.TooShort] || '';
  }

  return null;
};
